var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.519,
    height: 21.829,
    viewBox: "0 0 20.519 21.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "registration",
    transform: "translate(-15.368 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39177",
    "data-name": "Path 39177",
    d: "M30.853,0H18.038a1.073,1.073,0,0,0-1.072,1.072V1.48H16.44a1.073,1.073,0,0,0-1.072,1.072v13.7a.32.32,0,1,0,.64,0V2.552a.433.433,0,0,1,.432-.432H29.255a.433.433,0,0,1,.432.432V20.757a.433.433,0,0,1-.432.432H16.44a.433.433,0,0,1-.432-.432V17.743a.32.32,0,1,0-.64,0v3.014a1.073,1.073,0,0,0,1.072,1.072H29.255a1.073,1.073,0,0,0,1.072-1.072v-.408h.526a1.073,1.073,0,0,0,1.072-1.072V5.137a.32.32,0,0,0-.64,0v14.14a.433.433,0,0,1-.432.432h-.408V2.552A1.073,1.073,0,0,0,29.373,1.48H17.606V1.072a.433.433,0,0,1,.432-.432H30.853a.433.433,0,0,1,.432.432V3.645a.32.32,0,1,0,.64,0V1.072A1.073,1.073,0,0,0,30.853,0Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39178",
    "data-name": "Path 39178",
    d: "M425.216,148.8H423.51a.722.722,0,0,0-.721.721v9.077c0,.006,0,.012,0,.018s0,.007,0,.01a.32.32,0,0,0,.015.074l0,.007c0,.01.008.019.012.029l0,0,1.049,2.1a.532.532,0,0,0,.982,0l1.049-2.1,0-.006q.006-.013.011-.027l0-.009a.317.317,0,0,0,.009-.034v0a.322.322,0,0,0,.005-.036s0-.008,0-.013,0-.011,0-.016v-9.077A.722.722,0,0,0,425.216,148.8Zm-.853,11.6-.737-1.477H425.1Zm.935-2.117h-1.869v-6.838H425.3Zm0-7.477h-1.869v-1.28a.082.082,0,0,1,.082-.082h1.706a.082.082,0,0,1,.082.082v1.28Z",
    transform: "translate(-390.051 -142.452)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39179",
    "data-name": "Path 39179",
    d: "M58.218,388.921a.662.662,0,0,0,.661.661h1.762a.662.662,0,0,0,.661-.661v-1.684l.73-.776a.32.32,0,0,0-.466-.438l-.554.589a.657.657,0,0,0-.371-.114H58.879a.662.662,0,0,0-.661.661Zm2.444-1v1a.021.021,0,0,1-.021.021h-.948a.321.321,0,0,0,.036-.032Zm-1.8-.759a.021.021,0,0,1,.021-.021h1.639l-.977,1.039-.573-.873a.318.318,0,0,0-.11-.1v-.041Zm0,1.142c.4.617.385.6.441.642h-.42a.021.021,0,0,1-.021-.021Z",
    transform: "translate(-41.023 -369.468)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39180",
    "data-name": "Path 39180",
    d: "M155.9,428.091h-6.793a.32.32,0,1,0,0,.64H155.9a.32.32,0,1,0,0-.64Z",
    transform: "translate(-127.735 -409.839)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39181",
    "data-name": "Path 39181",
    d: "M58.964,82.112h5.669a.747.747,0,0,0,.746-.746V75.7a.747.747,0,0,0-.746-.746H58.964a.747.747,0,0,0-.746.746v5.669A.747.747,0,0,0,58.964,82.112ZM58.858,75.7a.107.107,0,0,1,.107-.107h5.669a.107.107,0,0,1,.107.107v5.669a.107.107,0,0,1-.107.107H58.964a.107.107,0,0,1-.107-.107Z",
    transform: "translate(-41.023 -71.755)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39182",
    "data-name": "Path 39182",
    d: "M105.829,106.824a.32.32,0,0,0,.32-.319v-.691a.928.928,0,0,1,.921-.925h.008a.928.928,0,0,1,.921.925v.371h-.677a.32.32,0,1,0,0,.64h1a.319.319,0,0,0,.32-.319v-.691a1.554,1.554,0,0,0-.458-1.106,1.584,1.584,0,0,0-.177-.153,1.461,1.461,0,1,0-1.858,0,1.585,1.585,0,0,0-.177.153,1.554,1.554,0,0,0-.458,1.106v.691a.319.319,0,0,0,.319.319Zm1.245-4.218a.821.821,0,0,1,0,1.643h-.005a.821.821,0,0,1,0-1.643Z",
    transform: "translate(-86.299 -97.62)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39183",
    "data-name": "Path 39183",
    d: "M242.157,112.207h2.826a.32.32,0,1,0,0-.64h-2.826a.32.32,0,0,0,0,.64Z",
    transform: "translate(-216.813 -106.81)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39184",
    "data-name": "Path 39184",
    d: "M242.157,154.728h2.826a.32.32,0,0,0,0-.64h-2.826a.32.32,0,0,0,0,.64Z",
    transform: "translate(-216.813 -147.518)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39185",
    "data-name": "Path 39185",
    d: "M242.157,200.081h2.826a.32.32,0,0,0,0-.64h-2.826a.32.32,0,0,0,0,.64Z",
    transform: "translate(-216.813 -190.938)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39186",
    "data-name": "Path 39186",
    d: "M58.538,272.5H69.193a.32.32,0,0,0,0-.64H58.538a.32.32,0,0,0,0,.64Z",
    transform: "translate(-41.023 -260.274)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39187",
    "data-name": "Path 39187",
    d: "M58.538,315.025H69.193a.32.32,0,0,0,0-.64H58.538a.32.32,0,0,0,0,.64Z",
    transform: "translate(-41.023 -300.981)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39188",
    "data-name": "Path 39188",
    d: "M58.538,357.545H69.193a.32.32,0,0,0,0-.64H58.538a.32.32,0,0,0,0,.64Z",
    transform: "translate(-41.023 -341.688)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/registration.fd274c23.svg";
export { ForwardRef as ReactComponent };